import React from "react";
import "../CSS/HomePage.css";

import Navbar from "../Components/Navbar/Navbar";
import InfiniteCardSlider from "../Functionality/Advertising/InfiniteCardSlider";
import { useNavigate } from "react-router-dom";
function Home() {
  const navigate = useNavigate()
  console.log("inside");
  return (
    <div>
      <Navbar />
      <button
        className="flex h-7 lg:ml-3 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
      onClick={() => {
          navigate("/QuickReports")
      }}
      >Quick Reports</button>
      <InfiniteCardSlider />
    </div>
  );
}
export default Home;
